import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=6a2c4066&scoped=true&"
import script from "./Reports.vue?vue&type=script&lang=js&"
export * from "./Reports.vue?vue&type=script&lang=js&"
import style0 from "./Reports.vue?vue&type=style&index=0&id=6a2c4066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c4066",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2c4066')) {
      api.createRecord('6a2c4066', component.options)
    } else {
      api.reload('6a2c4066', component.options)
    }
    module.hot.accept("./Reports.vue?vue&type=template&id=6a2c4066&scoped=true&", function () {
      api.rerender('6a2c4066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Reports.vue"
export default component.exports